import Card from "@/components/ui/Card";

const StepCard = ({
  stepNumber,
  icon: Icon,
  title,
  description,
  learnMoreText,
  borderColor = "border-blue-500",
  iconBgColor = "bg-blue-100",
  iconColor = "text-blue-600",
  onClick,
}) => {
  const borderColorClass = borderColor.split('-')[1];
  
  return (
    <button onClick={onClick} className="text-left h-full w-full">
      <Card className={`text-center p-6 hover:shadow-xl hover:border-${borderColorClass}-500 transition-all border-l-4 ${borderColor} cursor-pointer group`}>
        <div className={`w-16 h-16 ${iconBgColor} dark:${iconBgColor.replace('100', '900/30')} rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform`}>
          <Icon className={`w-8 h-8 ${iconColor} dark:${iconColor.replace('600', '400')}`} />
        </div>
        <div className={`w-8 h-8 bg-${borderColorClass}-500 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-sm font-bold`}>
          {stepNumber}
        </div>
        <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">
          {title}
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-300">
          {description}
        </p>
        <div className={`mt-4 inline-flex items-center text-${borderColorClass}-600 dark:text-${borderColorClass}-400 font-semibold text-sm group-hover:translate-x-1 transition-transform`}>
          {learnMoreText} →
        </div>
      </Card>
    </button>
  );
};

export default StepCard;